import { observer } from 'mobx-react-lite'
import { Platform, StyleSheet, View } from 'react-native'
import VideoIcon from '../../../assets/Video.svg'
import { BottomModalButton } from '../../BottomModalButton'
import RemovePlayerIcon from './assets/RemovePlayer.svg'
import { BottomSheetView } from '@gorhom/bottom-sheet'

export interface PlayerOptionsProps {
  onJoinVideoCall: () => void
  onRemovePlayer?: () => void
}

export const PlayerOptions = observer(({ onJoinVideoCall, onRemovePlayer }: PlayerOptionsProps) => {
  return (
    <BottomSheetView style={Platform.OS !== 'web' ? { flex: 1 } : {}}>
      <View style={styles.bottomSheetContainer}>
        <View style={styles.container}>
          <BottomModalButton
            icon={VideoIcon}
            text="Join video call"
            onPress={onJoinVideoCall}
            size="large"
            alternateColor
          />
          <BottomModalButton
            icon={RemovePlayerIcon}
            text="Remove player"
            onPress={onRemovePlayer}
            size="large"
            alternateColor
          />
        </View>
      </View>
    </BottomSheetView>
  )
})

const styles = StyleSheet.create({
  bottomSheetContainer: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: '#F6F2E9'
  },
  container: {
    flex: 1,
    gap: 20,
    width: '80%',
    justifyContent: 'center'
  }
})
